<article
  class="selectable-card flex flex--column border rounded-large white-bg surface-primary font-body-1 nordic-blue-900"
>
  <header>
    @if (isReadonly()) {
      <div
        [attr.data-testid]="testId()"
        class="selectable-card__row"
        [class.selectable-card__row--disabled]="isDisabled()"
        [class.selectable-card__row--interactive]="isInteractive()"
        [class.selectable-card__row--readonly]="isReadonly()"
        [class.selectable-card__row--selected]="isSelected()"
      >
        <ng-container *ngTemplateOutlet="rowContent"></ng-container>
      </div>
    } @else {
      <label
        [attr.data-testid]="testId()"
        class="selectable-card__row"
        [attr.for]="inputId()"
        [attr.aria-disabled]="isDisabled() ? 'true' : null"
        [class.selectable-card__row--disabled]="isDisabled()"
        [class.selectable-card__row--interactive]="isInteractive()"
        [class.selectable-card__row--readonly]="isReadonly()"
        [class.selectable-card__row--selected]="isSelected()"
      >
        <ng-container *ngTemplateOutlet="rowContent"></ng-container>
      </label>
    }
  </header>

  <div class="selectable-card__divider border-bottom-dashed"></div>

  <ng-content select="fcom-selectable-card-content"></ng-content>

  @if (hasFooter) {
    <div class="selectable-card__divider border-bottom-dashed"></div>
  }

  <ng-content select="fcom-selectable-card-footer"></ng-content>
</article>

<ng-template #rowContent>
  <div class="selectable-card__selection flex flex--middle fill">
    @if (isSelectable()) {
      @if (control()) {
        <input
          class="is-vishidden"
          type="checkbox"
          [id]="inputId()"
          [formControl]="$any(control())"
          [attr.aria-describedby]="describedBy()"
        />
      } @else {
        <input
          class="is-vishidden"
          type="checkbox"
          [id]="inputId()"
          [checked]="checked()"
          [disabled]="isDisabled()"
          [attr.aria-describedby]="describedBy()"
          (change)="onSelectionChange($event)"
        />
      }
    }

    @if (isSelectable()) {
      <ng-container *ngTemplateOutlet="selectionControl"></ng-container>
    }

    <ng-content select="fcom-selectable-card-header"></ng-content>
  </div>
</ng-template>

<ng-template #selectionControl>
  <span class="selectable-card__control flex" aria-hidden="true">
    @if (isSelected()) {
      <fcom-icon data-testid="icon-selected" class="icon-medium" [name]="SvgLibraryIcon.CHECKBOX_SELECTED" />
    } @else {
      <fcom-icon data-testid="icon-unselected" class="icon-medium" [name]="SvgLibraryIcon.CHECKBOX_UNSELECTED" />
    }
  </span>
</ng-template>
